
import { getHistoryInstance } from 'hooks/useHistory'
import { Store } from 'redux'
import store from 'redux/store'

/**
 * Returns the entity id based on the current URL, if available
 *
* @returns {(number | null)} the entity id or null
 */
export const getEntityIdFromCurrentUrl = (reduxStore: Store = store) => {
  return getEntityIdFromPathname(getHistoryInstance().location.pathname, reduxStore)
}

export const getEntityIdFromUrl = (url: string, reduxStore: Store = store) => {
  const { pathname } = new URL(url)
  return getEntityIdFromPathname(pathname)
}

/**
 * Extract the entity id from a given pathname
 *
* @returns {(number | null)} the entity id or null
 */
export const getEntityIdFromPathname = (pathname: string, reduxStore: Store = store): string | null => {
  if (pathname.startsWith('/handbook/')) {
    if (pathname.match(/\/handbook\/.+\/.+/)) {
      const slug = pathname.split('/')[3]
      return slug.split('-').pop() as string
    }
    const _store = reduxStore.getState()
    return _store.handbook?.cover_doc?.id || null
  }

  if (pathname.match(/\/folders\/.+\/.+/)) {
    const slug = pathname.split('/')[3]
    return slug.split('-').pop() as string
  }

  if (pathname.match(/\/folders\/.+/)) {
    const slug = pathname.split('/')[2]
    return slug.split('-').pop() || null
  }

  if (pathname.match(/\/designs\/.+/)) {
    return pathname.split('/')[2]
  }

  if (!pathname.startsWith('/docs/')) return null

  const slug = pathname.split('/')[2]
  return slug.split('-').pop() as string
}
